import React, { useState, useEffect } from 'react';
import UserView from './components/UserView';
import AdminPanel from './components/AdminPanel';
import Login from './components/Login';

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  // Check if we're in admin mode based on URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('admin') === 'true') {
      setShowLogin(true);
    }
  }, []);

  const handleLoginSuccess = () => {
    setShowLogin(false);
    setIsAdmin(true);
  };

  const handleLogout = () => {
    setIsAdmin(false);
    setShowLogin(true);
  };

  return (
    <div className="App">
      {showLogin ? (
        <Login onLoginSuccess={handleLoginSuccess} />
      ) : isAdmin ? (
        <AdminPanel onLogout={handleLogout} />
      ) : (
        <UserView />
      )}
    </div>
  );
}

export default App;